import { apiPost } from '../ApiClient';

/**
 * Fetch items for the POS item grid.
 * Uses the ERPNext point_of_sale whitelisted method.
 *
 * @param {Object} params
 * @param {number} params.start - Pagination offset (default 0)
 * @param {number} params.pageLength - Items per page (default 40)
 * @param {string} params.searchTerm - Text / barcode search
 * @param {string} params.posProfile - POS Profile name
 * @param {string} params.priceList - Selling Price List name
 * @param {string} params.itemGroup - Item Group filter
 * @returns {Promise<Array>} Array of item objects
 */
export async function fetchItems({
  start = 0,
  pageLength = 40,
  searchTerm = '',
  posProfile,
  priceList,
  itemGroup,
}) {
  const res = await apiPost(
    'method/erpnext.selling.page.point_of_sale.point_of_sale.get_items',
    {
      start,
      page_length: pageLength,
      price_list: priceList,
      item_group: itemGroup || 'All Item Groups',
      pos_profile: posProfile,
      search_term: searchTerm,
    },
  );
  return res?.message?.items || [];
}

/**
 * Search by barcode, serial number, or batch number.
 * Returns item_code + identifiers if found, empty object otherwise.
 *
 * @param {string} searchValue - Barcode / serial / batch string
 * @returns {Promise<Object>} { item_code, barcode, serial_no, batch_no } or {}
 */
export async function searchBarcode(searchValue) {
  const res = await apiPost(
    'method/erpnext.selling.page.point_of_sale.point_of_sale.search_for_serial_or_batch_or_barcode_number',
    { search_value: searchValue },
  );
  return res?.message || {};
}
